import axios from "axios";
import {initialCancelFunction} from "../../../../util/Helpers"

const cancelToken = axios.CancelToken;
let cancelSearchInstrumentReq = initialCancelFunction;

export const INSTRUMENTS_URL = "/instruments";

// READ
export function getSearchInstruments(query, limit) {
  cancelSearchInstrumentReq("Cancel Request");
  return axios.get(`${INSTRUMENTS_URL}?query=${query}&limit=${limit}`, {
      cancelToken: new cancelToken(function executor(cancel) {
        // An executor function receives a cancel function as a parameter
        cancelSearchInstrumentReq = cancel;
      })
    } 
  );
}
